const heading = {
  baseStyle: {
    color: "text.heading",
    fontWeight: "semibold",
    lineHeight: "full",
    fontFamily: "Inter",
  },
  sizes: {
    h1: {
      fontSize: "24px",
      letterSpacing: "-0.36px",
      span: {
        display: "block",
        color: "text.body",
        fontSize: "16px",
        fontWeight: "normal",
        lineHeight: "125%",
        letterSpacing: "-0.096px",
        mt: "6px",
      },
    },
    h2: {
      fontSize: "20px",
      letterSpacing: "-0.3px",
    },
    h3: {
      fontSize: "18px",
      lineHeight: "133.333%",
      letterSpacing: "-0.27px",
      span: {
        display: "block",
        color: "text.body",
        fontSize: "13px",
        fontWeight: "normal",
        lineHeight: "125%",
        letterSpacing: "-0.096px",
        mt: "6px",
      },
    },
    h4: {
      fontSize: "16px",
      fontWeight: "medium",
      lineHeight: "150%",
      letterSpacing: "-0.096px",
      span: {
        display: "block",
        color: "text.body",
        fontSize: "12px",
        fontWeight: "regular",
        lineHeight: "200%",
        letterSpacing: "-0.072px",
      },
    },
  },
};

export default heading;
